import { IBrandCartV2WithSummary } from "@faire/deprecated-retailer-visitor-shared/stores/domain/CartStore/consts";
import { BrandCartsSortBy } from "@faire/web-api--source/faire/carts/BrandCartsSortBy";
import { IBrandCartV2 } from "@faire/web-api--source/faire/carts/IBrandCartV2";
import { IGetCartRequest } from "@faire/web-api--source/faire/carts/IGetCartRequest";
import { IShippingMethod } from "@faire/web-api--source/indigofair/data/IShippingMethod";
import { isNotUndefined } from "@faire/web/common/typescriptUtils";

const CART_SORT_BY = BrandCartsSortBy.UPDATED_AT;
const EXCLUDE_ALCOHOL_DISCLAIMER = true;

// Shipping method type to do initial fetch on page load, as well as prefetching carts.
export const INITIAL_SHIPPING_METHOD_TYPE:
  | keyof typeof IShippingMethod.ShippingMethodType
  | undefined = undefined;

/**
 * Helper function to get a checkout cart request. Builds the request with the defaults
 * for the checkout cart such that prefetching and querying the checkout cart are the same.
 */
export const getCheckoutCartRequest = (
  brandTokens: string[],
  selectedShippingMethodType?: keyof typeof IShippingMethod.ShippingMethodType
): IGetCartRequest =>
  IGetCartRequest.build({
    brand_tokens: brandTokens,
    sort_brand_carts_by: CART_SORT_BY,
    exclude_alcohol_disclaimer: EXCLUDE_ALCOHOL_DISCLAIMER,
    shipping_method_type: selectedShippingMethodType,
  });

export const getCheckoutImprovedCartBrands = (
  brandCarts?: IBrandCartV2[]
): IBrandCartV2WithSummary[] => {
  if (!brandCarts) {
    return [];
  }
  // Note: Cart Summary data needs to be fetched separately or passed in.
  // This simplified version doesn't include the summary part.
  return brandCarts.map((brand: IBrandCartV2) => {
    return {
      ...brand,
      checkout_summary: undefined,
      is_eori_missing: false,
    };
  });
};

export const getImprovedCartBrandsReadyForCheckout = (
  brandCarts?: IBrandCartV2[]
): IBrandCartV2WithSummary[] => {
  const improvedCartBrands = getCheckoutImprovedCartBrands(brandCarts);
  return improvedCartBrands.filter(
    (brand) => brand.state === IBrandCartV2.State.READY_FOR_CHECKOUT
  );
};

export const getAvailableCartBrands = (
  checkoutCartBrands: IBrandCartV2WithSummary[],
  brandTokens?: string[]
): IBrandCartV2WithSummary[] => {
  const availableCarts = checkoutCartBrands;

  if ((brandTokens?.length ?? 0) > 0) {
    return availableCarts.filter(
      (b) => b.brand_token && brandTokens?.includes(b.brand_token)
    );
  }

  return availableCarts;
};

export const getAvailableBrandTokens = (
  checkoutCartBrands: IBrandCartV2WithSummary[],
  brandTokens?: string[]
): string[] => {
  const availableImprovedCartBrands = getAvailableCartBrands(
    checkoutCartBrands,
    brandTokens
  );
  return availableImprovedCartBrands
    .map((brand) => brand.brand_token)
    .filter(isNotUndefined);
};
